import React from 'react'
import { AvatarCompat } from 'components/shared/AvatarCompat'
import EmailCaptureCloseButton from '../CloseButton'

import { FontFamilies } from '../constants'

import './style.styl'

const UnsubmittedEmailCapturePlaybookPreview = ({ title, message, previewUser, fontFamily }) => (
  <div className="email-capture-playbook-preview--root" style={{ fontFamily: FontFamilies[fontFamily] }}>
    <div className="unsubmitted-email-capture-playbook-preview--header">
      <div className="unsubmitted-email-capture-playbook-preview--header-text">
        <h3 className="email-capture-playbook-preview--title">{title}</h3>
        <AvatarCompat size="medium" user={previewUser}/>
      </div>
      <EmailCaptureCloseButton/>
      <p className="email-capture-playbook-preview--description" dangerouslySetInnerHTML={{ __html: message }}/>
    </div>
    <div className="unsubmitted-email-capture-playbook-preview--input">
      <span>Email address</span>
    </div>
  </div>
)

export default UnsubmittedEmailCapturePlaybookPreview


// WEBPACK FOOTER //
// ./src/scripts/components/shared/PlaybookPreviews/EmailCapture/UnsubmittedPreview.js